import PropTypes from 'prop-types';

export const propTypes = {
  availableColumns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  lookupData: PropTypes.arrayOf(PropTypes.shape()),
  entityFilterConfig: PropTypes.shape({
    SEARCH_ACTION: PropTypes.string,
    UPDATE_CONFIGURATION: PropTypes.string,
    UPDATE_TABLE_CONFIGURATION: PropTypes.string,
    UPDATE_FILTER_CONFIG: PropTypes.string,
    REDUX_STATE: PropTypes.string,
    REMOVE_USER_DEFAULT_FILTER: PropTypes.string,
  }).isRequired,
  customPageSize: PropTypes.number.isRequired,
  entityId: PropTypes.number.isRequired,
  screenName: PropTypes.string,
  triggerActivateDataGrid: PropTypes.func,
  resetPreSelectedFilterConfig: PropTypes.func,
  loadPreSelectedFilterConfig: PropTypes.bool.isRequired,
  freezeColumn: PropTypes.string,
  paramForFreezeColumn: PropTypes.arrayOf(PropTypes.shape()),
  listActive: PropTypes.bool,
  activateDataGrid: PropTypes.bool,
  defaultNewCustomFilter: PropTypes.shape({}), // Props for craeting a new custom filter on load
  onSearchClick: PropTypes.func,
  isExtSrceen: PropTypes.shape(),
  filterPanelExpanded: PropTypes.bool,
  setFilterPanelExpanded: PropTypes.func,
};
export const defaultProps = {
  lookupData: null,
  screenName: '',
  triggerActivateDataGrid: () => undefined,
  freezeColumn: null,
  paramForFreezeColumn: [],
  resetPreSelectedFilterConfig: () => undefined,
  listActive: false,
  activateDataGrid: false,
  defaultNewCustomFilter: null,
  onSearchClick: () => undefined,
  isExtSrceen: null,
  filterPanelExpanded: undefined,
  setFilterPanelExpanded: null,
};
